import { render, staticRenderFns } from "./Vscode.vue?vue&type=template&id=095f7784&scoped=true"
import script from "./Vscode.vue?vue&type=script&lang=js"
export * from "./Vscode.vue?vue&type=script&lang=js"
import style0 from "./Vscode.vue?vue&type=style&index=0&id=095f7784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f7784",
  null
  
)

export default component.exports